import { Link } from 'react-router-dom';
import type { FAQItem } from '../../data/faq';
import { getArticleById } from '../../lib/content';
import { articlePath } from '../../lib/routes';
import type { Profile } from '../../types/profile';

export function FAQAccordion({ item, profile }: { item: FAQItem; profile: Profile }) {
  const related = item.relatedArticle ? getArticleById(item.relatedArticle) : undefined;

  return (
    <details id={`faq-${item.id}`} className="faq-item">
      <summary>{item.question}</summary>
      <div className="faq-answer">
        <p>{item.answer}</p>
        {related ? (
          <Link to={articlePath(profile, related.meta.category, related.meta.slug)}>Leia o tutorial completo →</Link>
        ) : null}
      </div>
    </details>
  );
}
